<ul class="notifications__container l-container">
    <li *ngFor="let notification of notifications">
        <tg-info-box
            class="notification__info-box"
            (click)="dismiss(notification)"
            [tgStyle]="getType(notification)"
            [ngSwitch]="notification.type"
            [ngClass]="{
            'notification__info-box--compact': isCompact
        }"
        >
            <tg-icon
                *ngSwitchCase="notificationTypeEnum.success"
                role="presentation"
                name="basic-tick-framed"
            >
            </tg-icon>
            <tg-icon
                *ngSwitchCase="notificationTypeEnum.primary"
                role="presentation"
                name="basic-info-framed"
            >
            </tg-icon>
            <tg-icon
                *ngSwitchCase="notificationTypeEnum.warning"
                role="presentation"
                name="lightbulb"
            >
            </tg-icon>
            <tg-icon
                *ngSwitchCase="notificationTypeEnum.danger"
                role="presentation"
                name="basic-warning-framed"
            >
            </tg-icon>
            <tg-info-box-heading *ngIf="notification.title">
                {{ notification.title }}
            </tg-info-box-heading>
            {{ notification.message }}
            <tg-info-box-actions *ngIf="notification.action">
                <button tgButton2 transparent (click)="onAction(notification)">
                    {{ notification.action.text }}
                </button>
            </tg-info-box-actions>
        </tg-info-box>
    </li>
</ul>
